export function Available30x30() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/30x30.png"
        className="available-format-img "
        alt="30x30"
      />
      <h6 className="text-center text-dark">30x30</h6>
    </div>
  );
}

export function Available24x32() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/24x32.png"
        className="available-format-img"
        alt="24x32"
      />
      <h6 className="text-center text-dark">24x32</h6>
    </div>
  );
}

export function Available20x30() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/20x30.png"
        className="available-format-img"
        alt="20x30"
      />
      <h6 className="text-center text-dark">20x30</h6>
    </div>
  );
}

export function Available20x30Planshet() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/20x30.png"
        className="available-format-img"
        alt="20x30"
      />
      <h6 className="text-center text-dark">20x30</h6>
    </div>
  );
}

export function Available19x19() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/19x19.png"
        className="available-format-img"
        alt="19x19"
      />
      <h6 className="text-center text-dark">19x19</h6>
    </div>
  );
}

export function Available19x19Planshet() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/19x19.png"
        className="available-format-img"
        alt="19x19"
      />
      <h6 className="text-center text-dark">19x19</h6>
    </div>
  );
}

export function Available23x23() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/23x23.png"
        className="available-format-img"
        alt="23x23"
      />
      <h6 className="text-center text-dark">23x23</h6>
    </div>
  );
}

export function Available23x23Planshet() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/23x23.png"
        className="available-format-img"
        alt="23x23"
      />
      <h6 className="text-center text-dark">23x23</h6>
    </div>
  );
}

export function Available23x18() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/23x18.png"
        className="available-format-img"
        alt="23x18"
      />
      <h6 className="text-center text-dark">23x18</h6>
    </div>
  );
}

export function Available18x24() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/18x24.png"
        className="available-format-img"
        alt="18x24"
      />
      <h6 className="text-center text-dark">18x24</h6>
    </div>
  );
}

export function Available18x24Planshet() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/18x24.png"
        className="available-format-img"
        alt="18x24"
      />
      <h6 className="text-center text-dark">18x24</h6>
    </div>
  );
}

export function Available29x19() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/29x19.png"
        className="available-format-img"
        alt="29x19"
      />
      <h6 className="text-center text-dark">29x19</h6>
    </div>
  );
}

export function Available29x19Planshet() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/29x19.png"
        className="available-format-img"
        alt="29x19"
      />
      <h6 className="text-center text-dark">29x19</h6>
    </div>
  );
}

export function Available30x20() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/30x20.png"
        className="available-format-img"
        alt="30x20"
      />
      <h6 className="text-center text-dark">30x20</h6>
    </div>
  );
}

export function Available20x20() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/20x20.png"
        className="available-format-img"
        alt="20x20"
      />
      <h6 className="text-center text-dark">20x20</h6>
    </div>
  );
}

export function Available15x15() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/15x15.png"
        className="available-format-img"
        alt="15x15"
      />
      <h6 className="text-center text-dark">15x15</h6>
    </div>
  );
}

export function Available15x20() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/15x20.png"
        className="available-format-img"
        alt="15x20"
      />
      <h6 className="text-center text-dark">15x20</h6>
    </div>
  );
}

export function Available20x15() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/20x15.png"
        className="available-format-img"
        alt="20x15"
      />
      <h6 className="text-center text-dark">20x15</h6>
    </div>
  );
}

export function AvailablePlanshetTrio20x30() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/trio.png"
        className="available-format-img"
        alt="trio"
      />
      <h6 className="text-center text-dark">Тріо 20x30</h6>
    </div>
  );
}

export function AvailablePlanshetTrumo30x20() {
  return (
    <div className="text-center">
      <img
        src="/images/services/photo/photobooks/formats/planshet/trumo.png"
        className="available-format-img"
        alt="trumo"
      />
      <h6 className="text-center text-dark">Трюмо 30x20</h6>
    </div>
  );
}

export function AvailableBamBooks() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати фотокниг Bambook:
        </p>

        <div className="row">
          <div className="col">{Available30x30()}</div>
          {/* <div className="col">{Available24x32()}</div> */}
          <div className="col">{Available20x30()}</div>
          <div className="col">{Available29x19()}</div>
          <div className="col">{Available19x19()}</div>
          <div className="col">{Available23x23()}</div>
        </div>
      </div>
    </>
  );
}

export function AvailableSlimBooks() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати фотокниг Slimbook:
        </p>

        <div className="row">
          <div className="col">{Available30x30()}</div>
          <div className="col">{Available20x30()}</div>
          {/* <div className="col">{Available18x24()}</div> */}
          <div className="col">{Available23x23()}</div>
          <div className="col">{Available29x19()}</div>
          <div className="col">{Available19x19()}</div>
          {/* <div className="col">{Available15x15()}</div> */}
        </div>
        
      </div>
    </>
  );
}

export function AvailableUniBooks() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати фотокниг Unibook:
        </p>

        <div className="row">
          <div className="col">{Available30x30()}</div>
          <div className="col">{Available20x30()}</div>
          <div className="col">{Available23x23()}</div>
          <div className="col">{Available29x19()}</div>
          <div className="col">{Available19x19()}</div>
        </div>

      </div>
    </>
  );
}

export function AvailablePrintBooks() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати фотокниг Printbook:
        </p>

        <div className="row">
          <div className="col">{Available23x23()}</div>
          {/* <div className="col">{Available24x32()}</div> */}
          <div className="col">{Available30x30()}</div>
          <div className="col">{Available20x30()}</div>
          <div className="col">{Available30x20()}</div>
          <div className="col">{Available20x20()}</div>
          {/* <div className="col">{Available15x20()}</div> */}
          {/* <div className="col">{Available20x15()}</div> */}
        </div>

      </div>
    </>
  );
}

export function AvailablePhotoBooks() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати фотокниг Photobook:
        </p>

        <div className="row">
          <div className="col">{Available30x30()}</div>
          <div className="col">{Available20x30()}</div>
          <div className="col">{Available18x24()}</div>
          <div className="col">{Available23x23()}</div>
          <div className="col">{Available29x19()}</div>
          <div className="col">{Available19x19()}</div>
        </div>

      </div>
    </>
  );
}

export function AvailablePlanshets() {
  return (
    <>
      <div className="col py-3" style={{ backgroundColor: "#e0e3e5" }}>
        <h1 className="text-center">Доступні формати</h1>
        <p className="text-center">
          Пропонуємо Вам наступні формати Планшетів:
        </p>

        <div className="row">
          <div className="col">{AvailablePlanshetTrumo30x20()}</div>
          <div className="col">{AvailablePlanshetTrio20x30()}</div>
          <div className="col">{Available20x30Planshet()}</div>
          {/* <div className="col">{Available18x24Planshet()}</div>
          <div className="col">{Available29x19Planshet()}</div>
          <div className="col">{Available23x23Planshet()}</div>
          <div className="col">{Available19x19Planshet()}</div> */}
        </div>

      </div>
    </>
  );
}
